
export default [{
        path: 'bridgewtlMQ',
        name: 'bridgewtlMQ',
        meta: {
            title: '桥梁养护质量',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/bridgeEvaluationSubsystem/bridgeMaintenanceQuality')
    },
    {
        path: 'bridgewtlAS',
        name: 'bridgewtlAS',
        meta: {
            title: '桥梁评价汇总',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/bridgeEvaluationSubsystem/bridgeAssessSummary')
    },
    {
        path: 'bridgewtlTSW',
        name: 'bridgewtlTSW',
        meta: {
            title: '桥梁技术状况预警',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/bridgeEvaluationSubsystem/bridgeTechnicalStatusWarning')
    },
    {
        path: 'bridgewtlDDT',
        name: 'bridgewtlDDT',
        meta: {
            title: '桥梁病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/bridgeEvaluationSubsystem/publicDiseaseDevelopmentTrendCopy')
    },
    {
        path: 'culvertwtlMQ',
        name: 'culvertwtlMQ',
        meta: {
            title: '涵洞养护质量',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/culvertEvaluationSubsystem/culvertMaintenanceQuality')
    },
    {
        path: 'culvertwtlAS',
        name: 'culvertwtlAS',
        meta: {
            title: '涵洞评价汇总',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/culvertEvaluationSubsystem/culvertAssessSummary')
    },
    {
        path: 'culvertwtlTSW',
        name: 'culvertwtlTSW',
        meta: {
            title: '涵洞技术状况预警',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/culvertEvaluationSubsystem/culvertTechnicalStatusWarning')
    },
    {
        path: 'culvertwtlDDT',
        name: 'culvertwtlDDT',
        meta: {
            title: '涵洞病害发展趋势',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/culvertEvaluationSubsystem/publicDiseaseDevelopmentTrendCopy')
    },
    {
        path: 'curingEffectAnalysis',
        name: 'curingEffectAnalysis',
        meta: {
            title: '养护效果分析',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/curingEffectAnalysisSystem/curingEffectAnalysis')
    },
    {
        path: 'curingEffectEvaluation',
        name: 'curingEffectEvaluation',
        meta: {
            title: '养护效果评定',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/curingEffectAnalysisSystem/curingEffectEvaluation')
    },
    {
        path: 'curingEffectEvaluationGather',
        name: 'curingEffectEvaluationGather',
        meta: {
            title: '养护效果评定汇总',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/curingEffectAnalysisSystem/curingEffectEvaluationGather')
    },
    {
        path: 'curingEffectEvaluationWarning',
        name: 'curingEffectEvaluationWarning',
        meta: {
            title: '养护效果分析预警',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/curingEffectAnalysisSystem/curingEffectEvaluationWarning')
    },
    {
        path: 'znjchz',
        name: 'znjchz',
        meta: {
            title: '决策汇总',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/jchz/index')
    },
    {
        path: 'zndiseaseDTrend',
        name: 'zndiseaseDTrend',
        meta: {
            title: '养护质量',
            auth: true
        },
        component: () =>
            import ('@/views/wtl/jchz/diseaseDTrend')
    },
]